import { render, staticRenderFns } from "./Trainingrecords.vue?vue&type=template&id=60af0e8d&scoped=true"
import script from "./Trainingrecords.vue?vue&type=script&lang=js"
export * from "./Trainingrecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60af0e8d",
  null
  
)

export default component.exports